(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bars = document.querySelectorAll('[data-announcement-bar]');

    bars.forEach(function(bar) {
      var slides = bar.querySelectorAll('.announcement-bar__slide');
      if (slides.length <= 1) return;

      var speed = parseInt(bar.getAttribute('data-speed'), 10) || 4;
      var current = 0;
      var transitioning = false;
      var paused = false;

      // Rotation pauses while hovered or focused, and never runs for
      // users who prefer reduced motion.
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      bar.addEventListener('mouseenter', function() { paused = true; });
      bar.addEventListener('mouseleave', function() { paused = false; });
      bar.addEventListener('focusin', function() { paused = true; });
      bar.addEventListener('focusout', function() { paused = false; });

      setInterval(function() {
        if (transitioning || paused || reducedMotion.matches) return;
        transitioning = true;

        var currentSlide = slides[current];
        var next = (current + 1) % slides.length;
        var nextSlide = slides[next];

        currentSlide.classList.add('is-exiting');
        currentSlide.classList.remove('is-active');

        nextSlide.classList.add('is-active');

        setTimeout(function() {
          currentSlide.classList.remove('is-exiting');
          current = next;
          transitioning = false;
        }, 550);
      }, speed * 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-videos"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.querySelectorAll('[data-social-videos]').forEach(function(track) {
      var videos = track.querySelectorAll('[data-social-video]');

      // Play clips only while on screen; reduced-motion users get the poster
      // and can start a clip by turning its sound on.
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            var video = entry.target;
            if (entry.isIntersecting && !reducedMotion.matches) {
              video.play().catch(function() {});
            } else if (!entry.isIntersecting) {
              video.pause();
            }
          });
        }, { threshold: 0.4 });
        videos.forEach(function(video) { observer.observe(video); });
      }

      // Only one clip plays with sound at a time.
      track.querySelectorAll('[data-social-video-sound]').forEach(function(button) {
        button.addEventListener('click', function() {
          var video = button.parentElement.querySelector('[data-social-video]');
          var turnOn = video.muted;

          track.querySelectorAll('[data-social-video-sound]').forEach(function(other) {
            var otherVideo = other.parentElement.querySelector('[data-social-video]');
            otherVideo.muted = true;
            other.setAttribute('aria-pressed', 'false');
            other.setAttribute('aria-label', 'Turn sound on');
          });

          if (turnOn) {
            video.muted = false;
            video.play().catch(function() {});
            button.setAttribute('aria-pressed', 'true');
            button.setAttribute('aria-label', 'Turn sound off');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
